export default __webpack_public_path__ + "static/media/kadubu.017c21a6.png";